import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { APP_DATE_FORMATS } from '../../service/date.adapter';

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
@Component({
    selector: 'kt-date-picker',
    templateUrl: './date-picker.component.html',
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: APP_DATE_FORMATS,
        },
    ],
    standalone: false
})
export class DatePickerComponent {
  @Output() valueChange = new EventEmitter();
  datePicker: any;
  firstDay: Date;
  lastDay: Date;
  minDate: any;
  ngOnInit() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); 

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    this.datePicker = new FormGroup({
      start: new FormControl(firstDay, [Validators.required]),
      end: new FormControl(lastDay, [Validators.required]),
    });
    this.minDate = this.datePicker.controls.start.value;
    // app-date-picker writes a plain Date into the control (unlike the old
    // Material + MomentDateAdapter input, which wrapped it in a Moment object
    // after a user pick) — react via valueChanges instead of a (dateChange)
    // template binding, same auto-update-End-Date behavior either way.
    this.datePicker.controls['start'].valueChanges.subscribe((value: Date | null) => this.onValueChange(value));
    this.valueChange.emit({
      fromDt: this.datePicker.controls['start'].value,
      toDt: this.datePicker.controls['end'].value
    });
  }
  viewReport(form:any) {
    if (form.valid) {
      this.valueChange.emit({
        fromDt: form.controls['start'].value,
        toDt: form.controls['end'].value
      });
    }
  }

  onValueChange(startDate: Date | null) {
    if (!startDate) return;
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const lastDayOfMonth = new Date(startYear, startMonth + 1, 0);
    this.datePicker.controls.end.setValue(lastDayOfMonth);
    this.minDate = startDate;
  }
}
